/**
 * If hero has no background, add background color to header
 */

document.addEventListener("DOMContentLoaded", function () {
    let hero = document.querySelector(".hero");
    let header = document.querySelector(".site-header");

    if (hero && header) {
        if (hero.classList.contains("hero-bg--no-media")) {
            header.classList.add("header-has-bg");
        } else {
            header.classList.remove("header-has-bg");
        }
    }
});